"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetType = void 0;
var AssetType;
(function (AssetType) {
    AssetType["IMAGE"] = "IMAGE";
    AssetType["VIDEO"] = "VIDEO";
    AssetType["QR_PORTAL_LINK"] = "QR_PORTAL_LINK";
})(AssetType = exports.AssetType || (exports.AssetType = {}));
